import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { ICard } from '../../models/card.model';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-card',
  imports: [MatCardModule, MatButtonModule, MatProgressSpinnerModule, FormsModule, DatePipe],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input()
  card!: ICard;

  deleteEvent() {
    this.card.delete();
  }

  saveEvent() {
    this.card.save();
  }
}
